import { Grid } from '@material-ui/core';
import React, { useEffect } from 'react';
import OpsPageContent from './OpsPageContent';
import OpsPageSidebar from './OpsPageSidebar';
import { useHistory, useLocation } from 'react-router-dom';

const OpsPage : React.FC = () => {
    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        if (location.pathname === '/ops') {
            history.push('/ops/create-node');
        }
    }, [location.pathname, history]);

    return (
        <Grid container direction='row' className="flex-gap-2" style={{height: '100vh'}}>
            <Grid item style={{height: '100vh'}}>
                <OpsPageSidebar />
            </Grid>
            <Grid item>
                <OpsPageContent />
            </Grid>
        </Grid>
    )
}

export default OpsPage;